// extracted by mini-css-extract-plugin
module.exports = {"body":"bill_body_1CdoH","body-title":"bill_body-title_1JZ-i","footer":"bill_footer_YLSGT"};